var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandWithPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "216px",
    height: "199px",
    viewBox: "0 0 216 199",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -235)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(62 209) translate(17 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.309 6.355c25.226 3.583 56.875 17.193 62.622 37.24 5.75 20.1-14.39 46.59-33.563 67.782-19.167 21.242-37.348 37.192-59.622 47.937-22.271 10.7-48.587 16.272-66.3 6.18-17.663-10.02-26.661-35.678-37.142-58.274C7.79 84.575-4.227 64.942 1.464 51.18c5.705-13.712 29.118-21.556 46.73-26.49 17.61-4.933 29.368-7.012 44.701-11.218 15.281-4.26 34.136-10.699 59.414-7.116z",
    fill: "#E7EEF2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.797 11.504c-4.045 0-5.31 6.348-5.31 8.886 0 4.305 4.55 22.088 8.848 22.088 4.297 0 8.85-17.53 8.85-19.548 0-2.018-5.31-11.426-12.388-11.426z",
    fill: "#FFD8C1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.897 6.362l61.54-.043a8 8 0 018.006 8.005L146.36 134a8 8 0 01-7.994 7.994l-61.541.043a8 8 0 01-8.006-8.006l.084-119.674a8 8 0 017.995-7.994z",
    fill: "#FF7EA2",
    fillRule: "nonzero",
    transform: "rotate(11.1 107.63 74.177)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.283 10.016l-.773 3.864c-.4 1.968-2.346 3.25-4.356 2.867l-26.39-5.075c-2.007-.392-3.314-2.3-2.926-4.269l.79-3.863",
    fill: "#145E7F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.666 118.41l76.617 16.103",
    stroke: "#145E7F",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.078 42.216l51.467-.005a2 2 0 012 2l-.001 12.832c0 1.105-.896 2-2 2l-51.467.005a2 2 0 01-2-2V44.216c.001-1.105.897-2 2-2z",
    fill: "#ECEEEC",
    transform: "rotate(12 111.81 50.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.386 62.932l51.467-.004a2 2 0 012 2l-.001 12.832c0 1.104-.896 2-2 2l-51.468.004a2 2 0 01-2-2l.001-12.832c0-1.104.896-2 2-2z",
    fill: "#E1F4EE",
    transform: "rotate(12 108.119 71.346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.433 83.724l51.467-.004a2 2 0 012 2l-.001 12.832c0 1.104-.896 2-2 2l-51.467.004a2 2 0 01-2-2l.001-12.832c0-1.104.896-2 2-2z",
    fill: "#ECEEEC",
    transform: "rotate(12 103.166 92.138)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#145E7F",
    fillRule: "nonzero",
    cx: 94.2477876,
    cy: 134.955752,
    r: 3.09734513
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.192 46.018c-5.34 0-8.9 4.088-8.9 8.437 0 14.316 8.136 26.076 11.703 26.076 7.625 0 10.42-4.092 10.42-6.904-.005-2.06-1.022-27.61-13.223-27.61zM63.524 83.638c1.553 1.49 13.467 13.663 13.467 22.107 0 5.718-1.296 10.184-12.175 10.184-5.18 0-19.683-19.624-19.683-27.572 0-4.472 2.849-14.906 10.879-14.906 2.331 0 7.512 3.976 8.287 4.969.798.793 1.644 1.54 2.535 2.236-.326 1.616-2.127 10.118-2.127 10.118M62.357 134.079c-.76 2.027-1.276 21.602 1.008 32.488-1.537 7.85-7.613 33.433-7.613 33.433h55.065l5.581-22.28s33.98-29.64 37.277-34.952c3.298-5.312 11.036-36.331 10.926-39.242-.09-2.024-37.04-33.169-38.054-34.436-1.015-1.267-18.858 16.563 10.824 37.083-.255 2.53-.24 13.708-.24 13.708s-20.647 7.082-22.743 8.61c-2.096 1.527-6.106 12.29-6.832 14.704-2.806-.546-45.2-9.116-45.2-9.116z",
    fill: "#FFD8C1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54 154.867c.376-2.111 2.201-9.695 2.655-11.504",
    stroke: "#000",
    strokeWidth: 3,
    opacity: 0.083937872,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandWithPhone);
export default __webpack_public_path__ + "static/media/hand-with-phone.b0e850a2740ea21279d9bdf4d175007f.svg";
export { ForwardRef as ReactComponent };